<div class="not-found-page">
  <div class="not-found-page__image"></div>
  <div class="not-found-page__message">
    <div class="not-found-page__title">
      {{ 'error.notFound' | translate }}
    </div>
    <div class="not-found-page__text">
      {{ 'error.notFoundMessage' | translate }}
    </div>
    <gl-button color-primary [text]="'error.goToAdmin' | translate" [routerLink]="['/home']"> </gl-button>
  </div>
  <div class="not-found-page__logo"></div>
</div>
